"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "19",
    height: "32",
    viewBox: "0 0 19 32"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M0,2.404 C0,1.076 1.076,0 2.4,0 L16.6,0 C17.926,0 19,1.067 19,2.404 L19,29.595 C19,30.923 17.924,32 16.6,32 L2.4,32 C1.074,32 0,30.932 0,29.595 L0,2.404 Z M2,26 L17,26 L17,2 L2,2 L2,26 Z M9.5,30.378 C10.171,30.378 10.714,29.834 10.714,29.162 C10.714,28.49 10.171,27.946 9.5,27.946 C8.829,27.946 8.286,28.49 8.286,29.162 C8.286,29.834 8.829,30.378 9.5,30.378 L9.5,30.378 Z"
  }));
};

exports["default"] = _default;